export default __webpack_public_path__ + "static/contact-photo-89b7634151ede3c4b8af37855acbfb1a.jpg";